<template>
    <SeoHead :overrides="overrides" />

    <AppToaster />
    <FlashToast />

    <slot name="head" />

    <CategoryPageLayoutHeader />

    <main v-if="slots.default && slots.default().length > 0" class="container mx-auto p-3">
        <DefaultTimer
            v-for="(timer, index) in categoryPage.timers"
            :key="`category_layout_timer_${index}`"
            :label="timer.label"
            :expired-label="timer.expired_label"
            :background-color="timer.background_color"
            :start-date="timer.start_date"
            :end-date="timer.end_date"
        />

        <Breadcrumbs />

        <slot />
    </main>

    <CategoryPageLayoutFooter />

    <!-- Reserves space so the floating mobile filter button doesn't cover the footer -->
    <div v-if="productStore.filtersEnabled" class="h-24 lg:hidden" />
</template>

<script setup lang="ts">
import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs.vue';
import FlashToast from '@/components/flash/FlashToast.vue';
import CategoryPageLayoutFooter from '@/components/layouts/category-page-layout/CategoryPageLayoutFooter.vue';
import CategoryPageLayoutHeader from '@/components/layouts/category-page-layout/CategoryPageLayoutHeader.vue';
import SeoHead from '@/components/seo/SeoHead.vue';
import DefaultTimer from '@/components/timers/DefaultTimer.vue';
import AppToaster from '@/components/toasters/AppToaster.vue';
import { categoryPageStore } from '@/stores/category/CategoryPageStore';
import { categoryProductStore } from '@/stores/category/CategoryProductStore';
import type { SeoOverrides } from '@/types/seo';
import { useSlots } from 'vue';

type MainLayoutProps = {
    overrides?: SeoOverrides;
};
const slots = useSlots();
const productStore = categoryProductStore();
const categoryPage = categoryPageStore();

withDefaults(defineProps<MainLayoutProps>(), {
    overrides: () => ({}),
});
</script>
